import { useDispatch, useSelector } from 'react-redux';
import useDeepCompareEffect from 'use-deep-compare-effect';
import get from 'lodash/get';

import * as Store from 'store';

import * as Actions from '../actions';
import * as Selectors from '../selectors';
import * as Types from '../types';

interface IChildren {
  items: Types.IEntity.Certificate[];
  meta: Types.IEntity.Meta;
  isFetched: boolean;
  isLoaded: boolean;
}

interface IProps {
  name: string;
  params?: Partial<Types.IParams>;
  filter?: Record<string, any>;
  onSuccess?: ({ items }: { items: Types.IEntity.Certificate[] }) => void;
  onError?: () => void;
  onFinally?: () => void;
}

const useReport = ({
  name,
  params = {},
  filter = {},
  onSuccess = () => { },
  onError = () => { },
  onFinally = () => { }
}: IProps): IChildren => {
  const dispatch = useDispatch();

  const items = useSelector<Store.Types.IState, Types.IEntity.Certificate[]>(state => Selectors.getList(state, name));
  const meta = useSelector<Store.Types.IState, Types.IEntity.Meta>(state =>
    get(state, `certificate.list[${name}].meta`)
  );
  const isFetched = useSelector<Store.Types.IState, boolean>(
    state => !!get(state, `certificate.list[${name}].isFetched`)
  );
  const isLoaded = useSelector<Store.Types.IState, boolean>(
    state => !!get(state, `certificate.list[${name}].isLoaded`)
  );

  useDeepCompareEffect(() => {
    dispatch(
      Actions.List.request({
        name,
        params: {
          search: params.search,
          page: params.page || 1,
          limit: params.limit || 10
        },
        filter,
        callback: {
          onSuccess,
          onError,
          onFinally
        }
      })
    );
  }, [params, filter]);

  return {
    items,
    meta,
    isFetched,
    isLoaded
  };
};

export default useReport;
